import React from "react";
import "./BusOffers.css";

const BusOffers = () => {
  const busOffers = [
    {
      id: 1,
      operator: "Volvo Bus Services",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Volvo_Buses_logo.svg/1280px-Volvo_Buses_logo.svg.png",
      offer: "UP TO 25% OFF",
      description: "Luxury AC sleeper buses with complimentary snacks",
      routes: "Mumbai • Pune • Bangalore • Hyderabad • Delhi",
      rating: "4.7/5",
      popular: true,
    },
    {
      id: 2,
      operator: "RedBus",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/RedBus_logo.svg/1280px-RedBus_logo.svg.png",
      offer: "FLAT ₹200 OFF",
      description: "Instant discount on all bus bookings",
      routes: "Pan India coverage",
      rating: "4.6/5",
      popular: true,
    },
    {
      id: 3,
      operator: "Maharashtra SRTC",
      logo: "https://upload.wikimedia.org/wikipedia/en/thumb/4/4f/Maharashtra_State_Road_Transport_Corporation_logo.png/220px-Maharashtra_State_Road_Transport_Corporation_logo.png",
      offer: "WEEKEND SPECIAL",
      description: "Extra discount on weekend travels",
      routes: "All Maharashtra routes",
      rating: "4.2/5",
      popular: false,
    },
    {
      id: 4,
      operator: "Orange Travels",
      logo: "https://images.railyatri.in/ry_images_prod/operator-1547129396.png",
      offer: "BUY 1 GET 1 FREE",
      description: "Companion offer on selected routes",
      routes: "South India routes",
      rating: "4.4/5",
      popular: true,
    },
    {
      id: 5,
      operator: "KPN Travels",
      logo: "https://images.railyatri.in/ry_images_prod/operator-1547128475.png",
      offer: "STARTING AT ₹499",
      description: "Budget friendly luxury buses",
      routes: "Tamil Nadu • Karnataka • Kerala",
      rating: "4.3/5",
      popular: false,
    },
    {
      id: 6,
      operator: "SRS Travels",
      logo: "https://images.railyatri.in/ry_images_prod/operator-1547129474.png",
      offer: "LUXURY DEAL",
      description: "Premium buses with extra leg space",
      routes: "North India routes",
      rating: "4.5/5",
      popular: true,
    },
    {
      id: 7,
      operator: "Hans Travels",
      logo: "https://images.railyatri.in/ry_images_prod/operator-1547128143.png",
      offer: "EARLY BIRD 15% OFF",
      description: "Book 7 days in advance and save",
      routes: "Delhi • Chandigarh • Himachal",
      rating: "4.1/5",
      popular: false,
    },
    {
      id: 8,
      operator: "Patel Travels",
      logo: "https://images.railyatri.in/ry_images_prod/operator-1547129087.png",
      offer: "GROUP BOOKING",
      description: "Special rates for group travels",
      routes: "Gujarat • Rajasthan • MP",
      rating: "4.4/5",
      popular: true,
    },
  ];

  // Fallback SVG for broken images
  const getFallbackSvg = (operatorName) => {
    return `data:image/svg+xml;base64,${btoa(`
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="12" fill="#F3F4F5"/>
        <text x="30" y="35" text-anchor="middle" fill="#676A7D" font-family="Arial, sans-serif" font-size="12">${
          operatorName.split(" ")[0]
        }</text>
      </svg>
    `)}`;
  };

  const handleImageError = (e, operatorName) => {
    e.target.src = getFallbackSvg(operatorName);
  };

  return (
    <div className="BusOffers">
      <div className="BusOffers-section-header">
        <h2>🚌 Exclusive Bus Deals</h2>
        <p>Special offers from premium bus operators</p>
      </div>

      <div className="BusOffers-scroll-container">
        <div className="BusOffers-scroll">
          {busOffers.concat(busOffers).map((offer, index) => (
            <div key={`${offer.id}-${index}`} className="BusOffers-card">
              {offer.popular && (
                <div className="BusOffers-popular-badge">Most Popular</div>
              )}

              <div className="BusOffers-card-header">
                <img
                  src={offer.logo}
                  alt={offer.operator}
                  className="BusOffers-logo"
                  onError={(e) => handleImageError(e, offer.operator)}
                />
                <div className="BusOffers-operator-info">
                  <h3>{offer.operator}</h3>
                  <div className="BusOffers-rating">
                    <span className="BusOffers-stars">★★★★★</span>
                    <span className="BusOffers-rating-text">
                      {offer.rating}
                    </span>
                  </div>
                </div>
              </div>

              <div className="BusOffers-card-body">
                <div className="BusOffers-offer-main">
                  <h4>{offer.offer}</h4>
                  <p>{offer.description}</p>
                </div>

                <div className="BusOffers-routes">
                  <span className="BusOffers-route-icon">🛣️</span>
                  <span className="BusOffers-route-text">{offer.routes}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BusOffers;
